export const SET_COMPANY = "setCompany";

export const setCompany = (payload: any) => {
  return {
    type: SET_COMPANY,
    payload,
  };
};
